import { useCallback } from 'react'
import { collection, serverTimestamp } from 'firebase/firestore'
import { addDoc } from '../lib/firestore'
import { db } from '../lib/firebase'
import { runMutation } from '../lib/firestoreMutation'
import { track } from '../lib/analytics'
import { fbt } from 'fbtee'

export type SuggestEventSource = 'filter_row' | 'parties_empty' | 'search_empty' | 'search_button'

// Suggestions are picked up by the process-event-suggestions routine, which
// seeds them and writes back status/eventIds via the admin SDK. Clients only
// ever create — rules reject updates.
export function useEventSuggestions(userId: string | null) {
  const suggestEvent = useCallback(
    async (url: string, groupIds: string[], source: SuggestEventSource) => {
      if (!userId) return
      await runMutation(
        fbt('Could not send your suggestion', 'Error toast when submitting an event suggestion fails'),
        async () => {
          await addDoc(collection(db, 'eventSuggestions'), {
            url: url.trim(),
            groupIds,
            submittedBy: userId,
            createdAt: serverTimestamp(),
            status: 'pending',
          })
          track('suggest_event', { entry_point: source, group_count: groupIds.length })
        },
      )
    },
    [userId],
  )

  return { suggestEvent }
}
